import { z } from 'zod';
import { EmployeeRole } from '~/modules/employees/enums/EmployeeRole';

export const CurrentEmployeeDtoSchema = z.object({
  id: z.string(),
  limsId: z.string(),
  testLabId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  middleName: z.string(),
  email: z.string(),
  phone: z.string(),
  role: z.nativeEnum(EmployeeRole),
});
export type CurrentEmployeeDto = z.infer<typeof CurrentEmployeeDtoSchema>;
